import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';

export const SelectedCount = styled(Text)`
    align-items: center;
    background: ${theme.colors.background.subtle};
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[4]};
    box-sizing: border-box;
    display: inline-flex;
    flex: none;
    height: 20px;
    justify-content: center;
    padding: 0;
    width: 20px;
`;
